module.exports = __webpack_public_path__ + "static/media/blom-a-generative-art-series-by-lucastswick-thumb-88.98d4ce49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-archive/blom-a-generative-art-series-by-lucastswick-thumb-88.jpg
// module id = 3652
// module chunks = 14